// La llave que trae el link de compra de los mails de suscripción (`?t=`).
//
// El mail es el único camino hacia /planes —la app no linkea la compra en
// ninguna plataforma— y se abre en el navegador, donde la sesión de la app no
// llega. La llave es lo que deja contratar igual, sin loguearse en el medio del
// recorrido. No es una sesión: lo único que habilita es pedir el link de pago de
// un plan a nombre de su dueño.

const CLAVE = "t";

/**
 * Lee la llave de la URL y la saca de la barra de direcciones en el mismo acto:
 * no tiene por qué quedar a la vista, ni viajar en una captura de pantalla o en
 * un link que alguien comparte. Del log de acceso del servidor no la podemos
 * sacar; dado lo poco que habilita, se acepta.
 *
 * Devuelve `null` cuando no hay llave, que es el caso de quien llegó a /planes
 * por su cuenta (googleando, o desde el login).
 *
 * @param {Window} ventana el `window` del navegador (parametrizado para poder testearlo)
 * @returns {string|null}
 */
export function leerYLimpiarToken(ventana = globalThis.window) {
    if (!ventana?.location?.href) return null;

    let url;
    try {
        url = new URL(ventana.location.href);
    } catch {
        return null;
    }

    const token = url.searchParams.get(CLAVE);
    if (!token) return null;

    url.searchParams.delete(CLAVE);
    try {
        ventana.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch {
        // Si el navegador no deja reescribir la URL, la llave queda a la vista.
        // Es peor perder la compra que dejarla en la barra: se sigue igual.
    }
    return token;
}
